//@ts-nocheck
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { RatingBars } from "../../../Constant";
import { BAR_RATING } from "../../../Data/Bonus Ui/Rating";
import { useState } from "react";
import Rating from "react-rating";
import { P } from "../../../AbstractElements";

const SimpleRatingBar = () => {
  const [rating, setRating] = useState(1);

  const handleRatingChange = (newRating:number) => setRating(newRating);

  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={RatingBars} span={BAR_RATING} />
        <CardBody>
          <div className="rating-container">
            <Rating start={0} stop={10} initialRating={rating} onClick={handleRatingChange}/>
            <P className="current-rating">Selected Rating: {rating}</P>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SimpleRatingBar;
